// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  min-height: 100vh;
  background: var(--mrt-bg);
}

.dashboard-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.dashboard-main--approved {
  max-width: none;
  padding: 16px 8px 24px;
}

.dashboard-approved-body {
  max-width: none;
  width: 100%;
  margin: 0;
}

/* PC: 양쪽 여백 + 중앙 정렬 */
@media (min-width: 1101px) {
  .dashboard-main--approved {
    max-width: 1280px;
    margin: 0 auto;
    padding: 28px 48px 36px;
    box-sizing: border-box;
  }

  .dashboard-approved-body {
    max-width: 1280px;
    margin: 0 auto;
  }

  .dashboard-cards {
    gap: 14px;
  }

  .dashboard-card {
    padding: 26px 14px 22px;
    min-height: 132px;
    border-radius: 16px;
  }

  .dashboard-card-icon svg {
    width: 48px;
    height: 48px;
  }

  .dashboard-card h3 {
    font-size: 0.92rem;
    font-weight: 500;
    letter-spacing: -0.045em;
    word-break: keep-all;
  }

  .dashboard-notice-banner {
    margin-left: 0;
    margin-right: 0;
  }
}

.dashboard-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.dashboard-layout--with-aside {
  grid-template-columns: minmax(0, 1fr) minmax(280px, 320px);
}

.dashboard-layout__main {
  min-width: 0;
}

.dashboard-approval-aside {
  min-width: 0;
}

@media (max-width: 1100px) {
  .dashboard-main--approved {
    padding-left: 4px;
    padding-right: 4px;
  }

  .dashboard-layout--with-aside {
    display: flex;
    flex-direction: column;
    grid-template-columns: none;
  }

  /* main 자식(카드·시스템정보)을 flex에 직접 참여 */
  .dashboard-layout__main {
    display: contents;
  }

  .dashboard-cards {
    order: 1;
    width: 100%;
    padding: 0 4px;
    box-sizing: border-box;
  }

  /* aside 자식을 레이아웃 플렉스에 직접 참여시켜 순서 제어 */
  .dashboard-approval-aside {
    display: contents;
  }

  /* 결재 대기 없음: 카드 → 결재 → 휴가 → 시스템정보(맨 아래) */
  .dashboard-aside-approval {
    order: 2;
  }

  .dashboard-aside-leave {
    order: 3;
  }

  .dashboard-info-section {
    order: 4;
    width: 100%;
    padding: 0 4px;
    box-sizing: border-box;
    margin-top: 4px;
  }

  /* 결재 대기 있음: 결재(맨 위) → 카드 → 휴가 → 시스템정보(맨 아래) */
  .dashboard-layout--approval-top .dashboard-aside-approval {
    order: 0;
  }

  .dashboard-layout--approval-top .dashboard-cards {
    order: 1;
  }

  .dashboard-layout--approval-top .dashboard-aside-leave {
    order: 3;
  }

  .dashboard-layout--approval-top .dashboard-info-section {
    order: 4;
  }

  .dap-panel {
    position: static;
    max-height: none;
  }
}

.welcome-section {
  background: var(--mrt-surface);
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.10);
  margin-bottom: 30px;
  border: 1px solid var(--mrt-border);
}

.welcome-section h2 {
  margin: 0 0 10px 0;
  color: var(--mrt-text);
  font-size: 1.8rem;
}

.welcome-section p {
  margin: 0;
  color: var(--mrt-text-2);
  font-size: 1.1rem;
}

.dashboard-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 16px;
  width: 100%;
}

.dashboard-card {
  background: var(--mrt-surface);
  padding: 24px 10px 20px;
  border-radius: 14px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  cursor: pointer;
  text-align: center;
  border: 1px solid var(--mrt-border);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 124px;
}

.dashboard-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
}

.dashboard-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  flex-shrink: 0;
  background: none;
  box-shadow: none;
  border-radius: 0;
  width: auto;
  height: auto;
}

.dashboard-card-icon svg {
  display: block;
}

/* legacy emoji slot — 미사용 */
.card-icon {
  display: none;
}

.card-icon--korea {
  display: none;
}

.dashboard-card h3 {
  margin: 0;
  color: var(--mrt-text);
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.045em;
  word-break: keep-all;
}

/* 당겨서 새로고침 */
.dashboard-ptr {
  width: 100%;
  touch-action: pan-y;
}

.dashboard-ptr__indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  overflow: hidden;
  color: var(--mrt-muted, #64748b);
  font-size: 13px;
  font-weight: 700;
  transition: height 0.15s ease, opacity 0.15s ease;
}

.dashboard-ptr__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(100, 116, 139, 0.25);
  border-top-color: #3b82f6;
  border-radius: 50%;
  flex-shrink: 0;
}

.dashboard-ptr--refreshing .dashboard-ptr__spinner {
  animation: dashboard-ptr-spin 0.7s linear infinite;
}

@keyframes dashboard-ptr-spin {
  to { transform: rotate(360deg); }
}

.dashboard-ptr__content {
  will-change: transform;
}

.dashboard-card p {
  margin: 0;
  color: var(--mrt-text-2);
  font-size: 0.68rem;
  line-height: 1.35;
}

.info-section {
  background: var(--mrt-surface);
  padding: 16px;
  border-radius: 10px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--mrt-border);
  width: 100%;
  box-sizing: border-box;
}

.info-section h3 {
  margin: 0 0 14px 0;
  color: var(--mrt-text);
  font-size: 1.1rem;
}

.info-grid {
  display: grid;
  gap: 15px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background: var(--mrt-surface-2);
  border-radius: 10px;
  align-items: center;
  border: 1px solid var(--mrt-border-2);
}

.info-label {
  font-weight: 600;
  color: var(--mrt-muted);
}

.info-value {
  color: var(--mrt-text);
}

.status-active {
  color: #28a745;
  font-weight: 600;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .dashboard-main {
    padding: 12px 4px 20px;
  }

  .dashboard-main--approved {
    padding-left: 4px;
    padding-right: 4px;
  }

  .dashboard-approved-body,
  .dashboard-layout,
  .dashboard-layout__main {
    width: 100%;
  }

  .dashboard-aside-approval,
  .dashboard-aside-leave {
    width: 100%;
    padding: 0 4px;
    box-sizing: border-box;
  }

  .dashboard-container .header-content {
    flex-direction: column;
    gap: 20px;
  }

  .dashboard-container .header-content h1 {
    font-size: 1.5rem;
  }

  .dashboard-container .user-info {
    width: 100%;
    justify-content: center;
  }

  .dashboard-cards {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
    width: 100%;
  }

  .dashboard-card {
    padding: 20px 6px 16px;
    border-radius: 10px;
    min-height: 112px;
    width: 100%;
  }

  .dashboard-card-icon svg {
    width: 40px;
    height: 40px;
  }

  .dashboard-card h3 {
    font-size: 0.84rem;
    font-weight: 500;
    letter-spacing: -0.05em;
    word-break: keep-all;
    line-height: 1.28;
  }

  .info-item {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
}

@media (max-width: 640px) {
  .dashboard-notice-banner {
    margin-left: 4px;
    margin-right: 4px;
  }
}

/* ── 대시보드 상단 공지사항 (최대 3건) ── */
.dashboard-notice-banner {
  margin: 0 8px 14px;
  padding: 0;
  border-radius: 0;
  border: none;
  background: transparent;
  box-shadow: none;
}

.dashboard-notice-banner__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dashboard-notice-item {
  width: 100%;
  text-align: left;
  border: 1px solid rgba(147, 197, 253, 0.45);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  padding: 10px 12px;
  cursor: pointer;
  font: inherit;
  transition: border-color 0.15s, background 0.15s;
}

.dashboard-notice-item:hover {
  border-color: rgba(37, 99, 235, 0.4);
  background: #fff;
}

.dashboard-notice-item--read {
  opacity: 0.82;
}

.dashboard-notice-item__row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.dashboard-notice-item__scope-group {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
}

.dashboard-notice-item__scope {
  display: inline-flex;
  align-items: center;
  height: 20px;
  font-size: 10px;
  font-weight: 700;
  color: #2563eb;
  background: rgba(37, 99, 235, 0.12);
  border-radius: 4px;
  padding: 0 6px;
  white-space: nowrap;
}

.dashboard-notice-item__new-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  background: linear-gradient(135deg, #fb923c, #f97316);
  color: #fff;
  font-size: 9px;
  font-weight: 900;
  line-height: 1;
}

.dashboard-notice-item__title {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.03em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-notice-item__date {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
}

.dashboard-notice-item__body {
  margin: 6px 0 0;
  padding-left: 2px;
  font-size: 12px;
  line-height: 1.6;
  color: #64748b;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 공지 상세 모달 */
.dashboard-notice-modal {
  position: fixed;
  inset: 0;
  z-index: 9250;
  height: 100dvh;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.dashboard-notice-modal__panel {
  width: 100%;
  max-width: 480px;
  max-height: min(85dvh, 720px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(37, 99, 235, 0.18);
  border: 1px solid rgba(147, 197, 253, 0.4);
  margin: auto;
}

.dashboard-notice-modal__head {
  padding: 22px 22px 18px;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);
  border-bottom: 1px solid rgba(147, 197, 253, 0.35);
  flex-shrink: 0;
}

.dashboard-notice-modal__head-top {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.dashboard-notice-modal__title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.45;
  letter-spacing: -0.03em;
  word-break: break-word;
}

.dashboard-notice-modal__date {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
}

.dashboard-notice-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1;
}

.dashboard-notice-modal__content {
  margin: 0;
  font-size: 14px;
  line-height: 1.75;
  color: #334155;
  white-space: pre-wrap;
  word-break: break-word;
}

.dashboard-notice-modal__close {
  margin: 0 22px 22px;
  padding: 12px 0;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.25);
}

.dashboard-notice-modal__close:hover {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
}

@media (max-width: 768px) {
  .dashboard-notice-modal {
    align-items: flex-start;
    padding: max(12px, env(safe-area-inset-top)) 12px max(12px, env(safe-area-inset-bottom));
  }

  .dashboard-notice-modal__panel {
    max-height: calc(100dvh - max(24px, env(safe-area-inset-top)) - max(24px, env(safe-area-inset-bottom)));
    border-radius: 16px;
  }

  .dashboard-notice-modal__head {
    padding: 18px 16px 14px;
  }

  .dashboard-notice-modal__body {
    padding: 16px;
  }

  .dashboard-notice-modal__close {
    margin: 0 16px 16px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA,mCAAmC;EACnC;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,cAAc;IACd,sBAAsB;EACxB;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;EACnB;;EAEA,yCAAyC;EACzC;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,eAAe;EACjB;;EAEA,8CAA8C;EAC9C;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;EACnC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;IAChD,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE;IACE,uBAAuB;IACvB,wFAAwF;EAC1F;;EAEA;IACE,uGAAuG;IACvG,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".dashboard-container {\n  min-height: 100vh;\n  background: var(--mrt-bg);\n}\n\n.dashboard-main {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n.dashboard-main--approved {\n  max-width: none;\n  padding: 16px 8px 24px;\n}\n\n.dashboard-approved-body {\n  max-width: none;\n  width: 100%;\n  margin: 0;\n}\n\n/* PC: 양쪽 여백 + 중앙 정렬 */\n@media (min-width: 1101px) {\n  .dashboard-main--approved {\n    max-width: 1280px;\n    margin: 0 auto;\n    padding: 28px 48px 36px;\n    box-sizing: border-box;\n  }\n\n  .dashboard-approved-body {\n    max-width: 1280px;\n    margin: 0 auto;\n  }\n\n  .dashboard-cards {\n    gap: 14px;\n  }\n\n  .dashboard-card {\n    padding: 26px 14px 22px;\n    min-height: 132px;\n    border-radius: 16px;\n  }\n\n  .dashboard-card-icon svg {\n    width: 48px;\n    height: 48px;\n  }\n\n  .dashboard-card h3 {\n    font-size: 0.92rem;\n    font-weight: 500;\n    letter-spacing: -0.045em;\n    word-break: keep-all;\n  }\n\n  .dashboard-notice-banner {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n.dashboard-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 24px;\n  align-items: start;\n}\n\n.dashboard-layout--with-aside {\n  grid-template-columns: minmax(0, 1fr) minmax(280px, 320px);\n}\n\n.dashboard-layout__main {\n  min-width: 0;\n}\n\n.dashboard-approval-aside {\n  min-width: 0;\n}\n\n@media (max-width: 1100px) {\n  .dashboard-main--approved {\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n\n  .dashboard-layout--with-aside {\n    display: flex;\n    flex-direction: column;\n    grid-template-columns: none;\n  }\n\n  /* main 자식(카드·시스템정보)을 flex에 직접 참여 */\n  .dashboard-layout__main {\n    display: contents;\n  }\n\n  .dashboard-cards {\n    order: 1;\n    width: 100%;\n    padding: 0 4px;\n    box-sizing: border-box;\n  }\n\n  /* aside 자식을 레이아웃 플렉스에 직접 참여시켜 순서 제어 */\n  .dashboard-approval-aside {\n    display: contents;\n  }\n\n  /* 결재 대기 없음: 카드 → 결재 → 휴가 → 시스템정보(맨 아래) */\n  .dashboard-aside-approval {\n    order: 2;\n  }\n\n  .dashboard-aside-leave {\n    order: 3;\n  }\n\n  .dashboard-info-section {\n    order: 4;\n    width: 100%;\n    padding: 0 4px;\n    box-sizing: border-box;\n    margin-top: 4px;\n  }\n\n  /* 결재 대기 있음: 결재(맨 위) → 카드 → 휴가 → 시스템정보(맨 아래) */\n  .dashboard-layout--approval-top .dashboard-aside-approval {\n    order: 0;\n  }\n\n  .dashboard-layout--approval-top .dashboard-cards {\n    order: 1;\n  }\n\n  .dashboard-layout--approval-top .dashboard-aside-leave {\n    order: 3;\n  }\n\n  .dashboard-layout--approval-top .dashboard-info-section {\n    order: 4;\n  }\n\n  .dap-panel {\n    position: static;\n    max-height: none;\n  }\n}\n\n.welcome-section {\n  background: var(--mrt-surface);\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.10);\n  margin-bottom: 30px;\n  border: 1px solid var(--mrt-border);\n}\n\n.welcome-section h2 {\n  margin: 0 0 10px 0;\n  color: var(--mrt-text);\n  font-size: 1.8rem;\n}\n\n.welcome-section p {\n  margin: 0;\n  color: var(--mrt-text-2);\n  font-size: 1.1rem;\n}\n\n.dashboard-cards {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 16px;\n  width: 100%;\n}\n\n.dashboard-card {\n  background: var(--mrt-surface);\n  padding: 24px 10px 20px;\n  border-radius: 14px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);\n  transition: all 0.2s ease;\n  cursor: pointer;\n  text-align: center;\n  border: 1px solid var(--mrt-border);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 124px;\n}\n\n.dashboard-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);\n}\n\n.dashboard-card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n  flex-shrink: 0;\n  background: none;\n  box-shadow: none;\n  border-radius: 0;\n  width: auto;\n  height: auto;\n}\n\n.dashboard-card-icon svg {\n  display: block;\n}\n\n/* legacy emoji slot — 미사용 */\n.card-icon {\n  display: none;\n}\n\n.card-icon--korea {\n  display: none;\n}\n\n.dashboard-card h3 {\n  margin: 0;\n  color: var(--mrt-text);\n  font-size: 0.95rem;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -0.045em;\n  word-break: keep-all;\n}\n\n/* 당겨서 새로고침 */\n.dashboard-ptr {\n  width: 100%;\n  touch-action: pan-y;\n}\n\n.dashboard-ptr__indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  overflow: hidden;\n  color: var(--mrt-muted, #64748b);\n  font-size: 13px;\n  font-weight: 700;\n  transition: height 0.15s ease, opacity 0.15s ease;\n}\n\n.dashboard-ptr__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(100, 116, 139, 0.25);\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.dashboard-ptr--refreshing .dashboard-ptr__spinner {\n  animation: dashboard-ptr-spin 0.7s linear infinite;\n}\n\n@keyframes dashboard-ptr-spin {\n  to { transform: rotate(360deg); }\n}\n\n.dashboard-ptr__content {\n  will-change: transform;\n}\n\n.dashboard-card p {\n  margin: 0;\n  color: var(--mrt-text-2);\n  font-size: 0.68rem;\n  line-height: 1.35;\n}\n\n.info-section {\n  background: var(--mrt-surface);\n  padding: 16px;\n  border-radius: 10px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);\n  border: 1px solid var(--mrt-border);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.info-section h3 {\n  margin: 0 0 14px 0;\n  color: var(--mrt-text);\n  font-size: 1.1rem;\n}\n\n.info-grid {\n  display: grid;\n  gap: 15px;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n  background: var(--mrt-surface-2);\n  border-radius: 10px;\n  align-items: center;\n  border: 1px solid var(--mrt-border-2);\n}\n\n.info-label {\n  font-weight: 600;\n  color: var(--mrt-muted);\n}\n\n.info-value {\n  color: var(--mrt-text);\n}\n\n.status-active {\n  color: #28a745;\n  font-weight: 600;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n  .dashboard-main {\n    padding: 12px 4px 20px;\n  }\n\n  .dashboard-main--approved {\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n\n  .dashboard-approved-body,\n  .dashboard-layout,\n  .dashboard-layout__main {\n    width: 100%;\n  }\n\n  .dashboard-aside-approval,\n  .dashboard-aside-leave {\n    width: 100%;\n    padding: 0 4px;\n    box-sizing: border-box;\n  }\n\n  .dashboard-container .header-content {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .dashboard-container .header-content h1 {\n    font-size: 1.5rem;\n  }\n\n  .dashboard-container .user-info {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .dashboard-cards {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 6px;\n    width: 100%;\n  }\n\n  .dashboard-card {\n    padding: 20px 6px 16px;\n    border-radius: 10px;\n    min-height: 112px;\n    width: 100%;\n  }\n\n  .dashboard-card-icon svg {\n    width: 40px;\n    height: 40px;\n  }\n\n  .dashboard-card h3 {\n    font-size: 0.84rem;\n    font-weight: 500;\n    letter-spacing: -0.05em;\n    word-break: keep-all;\n    line-height: 1.28;\n  }\n\n  .info-item {\n    flex-direction: column;\n    gap: 8px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 640px) {\n  .dashboard-notice-banner {\n    margin-left: 4px;\n    margin-right: 4px;\n  }\n}\n\n/* ── 대시보드 상단 공지사항 (최대 3건) ── */\n.dashboard-notice-banner {\n  margin: 0 8px 14px;\n  padding: 0;\n  border-radius: 0;\n  border: none;\n  background: transparent;\n  box-shadow: none;\n}\n\n.dashboard-notice-banner__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dashboard-notice-item {\n  width: 100%;\n  text-align: left;\n  border: 1px solid rgba(147, 197, 253, 0.45);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.92);\n  padding: 10px 12px;\n  cursor: pointer;\n  font: inherit;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.dashboard-notice-item:hover {\n  border-color: rgba(37, 99, 235, 0.4);\n  background: #fff;\n}\n\n.dashboard-notice-item--read {\n  opacity: 0.82;\n}\n\n.dashboard-notice-item__row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.dashboard-notice-item__scope-group {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  line-height: 1;\n}\n\n.dashboard-notice-item__scope {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #2563eb;\n  background: rgba(37, 99, 235, 0.12);\n  border-radius: 4px;\n  padding: 0 6px;\n  white-space: nowrap;\n}\n\n.dashboard-notice-item__new-badge {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  background: linear-gradient(135deg, #fb923c, #f97316);\n  color: #fff;\n  font-size: 9px;\n  font-weight: 900;\n  line-height: 1;\n}\n\n.dashboard-notice-item__title {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.03em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dashboard-notice-item__date {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.dashboard-notice-item__body {\n  margin: 6px 0 0;\n  padding-left: 2px;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #64748b;\n  white-space: pre-wrap;\n  word-break: break-word;\n  text-align: left;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* 공지 상세 모달 */\n.dashboard-notice-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 9250;\n  height: 100dvh;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.dashboard-notice-modal__panel {\n  width: 100%;\n  max-width: 480px;\n  max-height: min(85dvh, 720px);\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(37, 99, 235, 0.18);\n  border: 1px solid rgba(147, 197, 253, 0.4);\n  margin: auto;\n}\n\n.dashboard-notice-modal__head {\n  padding: 22px 22px 18px;\n  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);\n  border-bottom: 1px solid rgba(147, 197, 253, 0.35);\n  flex-shrink: 0;\n}\n\n.dashboard-notice-modal__head-top {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.dashboard-notice-modal__title {\n  margin: 0 0 8px;\n  font-size: 18px;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.45;\n  letter-spacing: -0.03em;\n  word-break: break-word;\n}\n\n.dashboard-notice-modal__date {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.dashboard-notice-modal__body {\n  padding: 20px 22px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.dashboard-notice-modal__content {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.75;\n  color: #334155;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.dashboard-notice-modal__close {\n  margin: 0 22px 22px;\n  padding: 12px 0;\n  border: none;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.25);\n}\n\n.dashboard-notice-modal__close:hover {\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n}\n\n@media (max-width: 768px) {\n  .dashboard-notice-modal {\n    align-items: flex-start;\n    padding: max(12px, env(safe-area-inset-top)) 12px max(12px, env(safe-area-inset-bottom));\n  }\n\n  .dashboard-notice-modal__panel {\n    max-height: calc(100dvh - max(24px, env(safe-area-inset-top)) - max(24px, env(safe-area-inset-bottom)));\n    border-radius: 16px;\n  }\n\n  .dashboard-notice-modal__head {\n    padding: 18px 16px 14px;\n  }\n\n  .dashboard-notice-modal__body {\n    padding: 16px;\n  }\n\n  .dashboard-notice-modal__close {\n    margin: 0 16px 16px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
